export const isLoggedIn = state => state.get('user').toJS().accountInfo.isLoggedIn;
